import CryptoJS from 'crypto-js';

export const generateEncryptedData = ()=>{
  const dataToEncrypt = {
    authUser: {
      employeeId: '21996',
      // name: 'natthakit singkhan',
    },
    language: 'en',
  };

  const dataToEncryptString = JSON.stringify(dataToEncrypt);
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const encryptedData = CryptoJS.AES.encrypt(dataToEncryptString, secretKey).toString();
  console.log('normal encryptedData', encryptedData);

  return encryptedData;
};
